import {setup, run} from '../../snippets/java';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  price: {},
  create: {},
  'payment-methods': {},
  'line-items': {},
  mode: {},
  redirect: {},
  urls: {},
  portal: {},
  'run-server': {
    Component: CreateShellCommand(run('stripe-billing-checkout')),
  },
};

export default ({keys, merchant, client}) => `package com.stripe.sample;

import java.nio.file.Paths;

import java.util.HashMap;
import java.util.Map;

import static spark.Spark.post;
import static spark.Spark.port;
import static spark.Spark.staticFiles;

import com.google.gson.Gson;
import com.google.gson.annotations.SerializedName;
import com.google.gson.JsonSyntaxException;

import com.stripe.Stripe;
import com.stripe.net.ApiResource;
import com.stripe.model.Event;
import com.stripe.model.EventDataObjectDeserializer;
import com.stripe.exception.SignatureVerificationException;
import com.stripe.net.Webhook;
import com.stripe.model.StripeObject;
import com.stripe.model.checkout.Session;
import com.stripe.param.checkout.SessionCreateParams;
import com.stripe.model.Price;
import com.stripe.param.PriceListParams;
import com.stripe.model.PriceCollection;
import com.stripe.model.Discount;
import com.stripe.model.Subscription;

public class Server {
  private static Gson gson = new Gson();

  public static void main(String[] args) {
    port(4242);

    {+setup}
    ${comment && comment(merchant)}
    Stripe.apiKey = "${keys.secret}";
    {/setup}
    // Replace this endpoint secret with your endpoint's unique secret
    // If you are testing with the CLI, find the secret by running 'stripe listen'
    // If you are using an endpoint defined with the API or dashboard, look in your webhook settings
    // at https://dashboard.stripe.com/webhooks
    String endpointSecret = "whsec_12345";
    final String YOUR_DOMAIN = "${
      client === 'react'
        ? 'http://localhost:3000/checkout'
        : 'http://localhost:4242'
    }";

    staticFiles.externalLocation(Paths.get("public").toAbsolutePath().toString());

    post("/create-checkout-session", (request, response) -> {
      {+price}
      PriceListParams priceParams = PriceListParams.builder().addLookupKeys(request.queryParams("lookup_key")).build();
      PriceCollection prices = Price.list(priceParams);
      {/price}

      {+create}
      SessionCreateParams params = SessionCreateParams.builder()
          {+payment-methods}
          .addPaymentMethodType(SessionCreateParams.PaymentMethodType.CARD)
          {/payment-methods}
          {+mode}
          {+line-items}
          .addLineItem(
              SessionCreateParams.LineItem.builder().setPrice(prices.getData().get(0).getId()).setQuantity(1L).build())
          {/line-items}
          .setMode(SessionCreateParams.Mode.SUBSCRIPTION)
          {/mode}
          {+urls}
          .setSuccessUrl(YOUR_DOMAIN + "${
            client === 'react'
              ? '?success=true&session_id={CHECKOUT_SESSION_ID}'
              : '/success.html?session_id={CHECKOUT_SESSION_ID}'
          }")
          .setCancelUrl(YOUR_DOMAIN + "${
            client === 'react' ? '?canceled=true' : '/cancel.html'
          }")
          {/urls}
          {?add-trial trial-period-days}
          .setSubscriptionData(SessionCreateParams.SubscriptionData.builder().setTrialPeriodDays(7L).build())
          {/trial-period-days}
          {?add-discount discounts}
          .addDiscount(SessionCreateParams.Discount.builder().setCoupon("{{COUPON_ID}}").build())
          {/discounts}
          {?add-customer customer}
          .setCustomer("cus_JyTTNqVDAoRYE1")
          {/customer}
          {?automatic-tax automatic-tax-param}
          .setAutomaticTax(
            SessionCreateParams.AutomaticTax.builder()
              .setEnabled(true)
              .build())
          {/automatic-tax-param}
          .build();
      Session session = Session.create(params);
      {/create}

      {+redirect}
      response.redirect(session.getUrl(), 303);
      {/redirect}
      return "";
    });

    post("/create-portal-session", (request, response) -> {
      // For demonstration purposes, we're using the Checkout session to retrieve the
      // customer ID.
      // Typically this is stored alongside the authenticated user in your database.
      // Deserialize request from our front end.
      Session checkoutSession = Session.retrieve(request.queryParams("session_id"));

      String customer = checkoutSession.getCustomer();
      // Authenticate your user.
      {+portal}
      com.stripe.param.billingportal.SessionCreateParams params = new com.stripe.param.billingportal.SessionCreateParams.Builder()
          .setReturnUrl(YOUR_DOMAIN).setCustomer(customer).build();

      com.stripe.model.billingportal.Session portalSession = com.stripe.model.billingportal.Session.create(params);

      {/portal}

      {+redirect-portal}
      response.redirect(portalSession.getUrl(), 303);
      return "";
      {/redirect-portal}
    });

    {+provision-access-webhooks}
    post("/webhook", (request, response) -> {
      String payload = request.body();
      Event event = null;
      try {
        event = ApiResource.GSON.fromJson(payload, Event.class);
      } catch (JsonSyntaxException e) {
        // Invalid payload
        System.out.println("⚠️  Webhook error while parsing basic request.");
        response.status(400);
        return "";
      }
      String sigHeader = request.headers("Stripe-Signature");
      if (endpointSecret != null && sigHeader != null) {
        // Only verify the event if you have an endpoint secret defined.
        // Otherwise use the basic event deserialized with GSON.
        try {
          event = Webhook.constructEvent(payload, sigHeader, endpointSecret);
        } catch (SignatureVerificationException e) {
          // Invalid signature
          System.out.println("⚠️  Webhook error while validating signature.");
          response.status(400);
          return "";
        }
      }
      // Deserialize the nested object inside the event
      EventDataObjectDeserializer dataObjectDeserializer = event.getDataObjectDeserializer();
      StripeObject stripeObject = null;
      if (dataObjectDeserializer.getObject().isPresent()) {
        stripeObject = dataObjectDeserializer.getObject().get();
      } else {
        // Deserialization failed, probably due to an API version mismatch.
        // Refer to the Javadoc documentation on \`EventDataObjectDeserializer\` for
        // instructions on how to handle this case, or return an error here.
      }
      // Handle the event
      Subscription subscription = null;
      switch (event.getType()) {
        case "customer.subscription.deleted":
          subscription = (Subscription) stripeObject;
          // Then define and call a function to handle the event
          // customer.subscription.deleted
          // handleSubscriptionTrialEnding(subscription);
        case "customer.subscription.trial_will_end":
          subscription = (Subscription) stripeObject;
          // Then define and call a function to handle the event
          // customer.subscription.trial_will_end
          // handleSubscriptionDeleted(subscriptionDeleted);
        case "customer.subscription.created":
          subscription = (Subscription) stripeObject;
          // Then define and call a function to handle the event
          // customer.subscription.created
          // handleSubscriptionCreated(subscription);
        case "customer.subscription.updated":
          subscription = (Subscription) stripeObject;
          // Then define and call a function to handle the event
          // customer.subscription.updated
          // handleSubscriptionUpdated(subscription);
          // ... handle other event types
        default:
          System.out.println("Unhandled event type: " + event.getType());
      }
      response.status(200);
      return "";
    });
    {/provision-access-webhooks}
  }
}`;
